export enum EnvironmentType {
  Production = 1,
  Sandbox = 2
}
